<section class="editor-page">
  <div class="editor-loader-overlay" *ngIf="editorLoading">
    <div class="editor-loader-content">
      <img src="assets/images/logo-wwtp.png" alt="Loading" class="editor-loader-logo" />
      <div class="editor-loader-text">Loading Document Editor...</div>
    </div>
  </div>
  <div class="editor-loader-overlay export-loader-overlay" *ngIf="exportInProgress">
    <div class="editor-loader-content export-loader-content">
      <img src="assets/images/logo-wwtp.png" alt="Exporting" class="editor-loader-logo" />
      <div class="editor-loader-text">{{ exportProgressText }}</div>
      <div class="export-progress-track" role="progressbar" [attr.aria-valuenow]="exportProgress" aria-valuemin="0" aria-valuemax="100">
        <div class="export-progress-fill" [style.width.%]="exportProgress"></div>
      </div>
      <div class="export-progress-value">{{ exportProgress }}%</div>
      <button type="button" class="toolbar-btn export-cancel-btn" (click)="cancelExport()">Cancel</button>
    </div>
  </div>

  <div class="editor-shell">
    <div class="toolbar">
      <div class="font-picker block-picker" #blockPickerRef>
        <button type="button" class="toolbar-select font-trigger" (click)="toggleBlockDropdown($event)">
          <span class="font-preview">{{ activeBlockLabel }}</span>
          <span class="caret">&#9662;</span>
        </button>
        <div class="font-dropdown" *ngIf="blockDropdownOpen">
          <button
            type="button"
            class="font-option"
            *ngFor="let option of blockOptions"
            [class.active]="option.value === activeBlock"
            (click)="selectBlock(option.value)"
          >
            {{ option.label }}
          </button>
        </div>
      </div>

      <div class="font-picker" #fontPickerRef>
        <button type="button" class="toolbar-select font-trigger" (click)="toggleFontDropdown($event)">
          <span class="font-preview" [style.font-family]="selectedFont">{{ selectedFont }}</span>
          <span class="caret">&#9662;</span>
        </button>
        <div class="font-dropdown" *ngIf="fontDropdownOpen">
          <button
            type="button"
            class="font-option"
            *ngFor="let font of fontFamilies"
            [class.active]="font === selectedFont"
            [style.font-family]="font"
            (click)="setFontFamily(font)"
          >
            {{ font }}
          </button>
        </div>
      </div>

      <div class="font-picker size-picker" #sizePickerRef>
        <button type="button" class="toolbar-select font-trigger" (click)="toggleSizeDropdown($event)">
          <span class="font-preview">{{ selectedFontSize }}</span>
          <span class="caret">&#9662;</span>
        </button>
        <div class="font-dropdown" *ngIf="sizeDropdownOpen">
          <button
            type="button"
            class="font-option"
            *ngFor="let size of fontSizes"
            [class.active]="size === selectedFontSize"
            (click)="selectFontSize(size)"
          >
            {{ size }}
          </button>
        </div>
      </div>

      <div class="font-picker line-spacing-picker" #lineSpacingPickerRef>
        <button type="button" class="toolbar-select font-trigger" (click)="toggleLineSpacingDropdown($event)">
          <span class="font-preview">{{ selectedLineSpacing }}</span>
          <span class="caret">&#9662;</span>
        </button>
        <div class="font-dropdown" *ngIf="lineSpacingDropdownOpen">
          <button
            type="button"
            class="font-option"
            *ngFor="let spacing of lineSpacingOptions"
            [class.active]="spacing === selectedLineSpacing"
            (click)="selectLineSpacing(spacing)"
          >
            {{ spacing }}
          </button>
        </div>
      </div>

      <button type="button" class="toolbar-btn" [class.active]="isBold" (click)="format('bold')"><b>B</b></button>
      <button type="button" class="toolbar-btn" [class.active]="isItalic" (click)="format('italic')"><i>I</i></button>
      <button type="button" class="toolbar-btn" [class.active]="isUnderline" (click)="format('underline')"><u>U</u></button>
      <button type="button" class="toolbar-btn" [class.active]="isStrike" (click)="format('strikeThrough')"><s>S</s></button>
      <button type="button" class="toolbar-btn" (click)="format('superscript')">X<sup>2</sup></button>
      <button type="button" class="toolbar-btn" (click)="format('subscript')">X<sub>2</sub></button>

      <button
        type="button"
        class="toolbar-btn list-format-btn"
        title="Bulleted List"
        aria-label="Bulleted List"
        (click)="format('insertUnorderedList')"
      >
        <span class="list-format-icon" aria-hidden="true">
          <span class="list-markers">• • •</span>
          <span class="list-lines">≡</span>
        </span>
      </button>
      <button
        type="button"
        class="toolbar-btn list-format-btn"
        title="Numbered List"
        aria-label="Numbered List"
        (click)="format('insertOrderedList')"
      >
        <span class="list-format-icon" aria-hidden="true">
          <span class="list-markers">1 2 3</span>
          <span class="list-lines">≡</span>
        </span>
      </button>
      <button type="button" class="toolbar-btn" (click)="format('outdent')">Outdent</button>
      <button type="button" class="toolbar-btn" (click)="format('indent')">Indent</button>

      <button type="button" class="toolbar-btn" (click)="format('justifyLeft')">Left</button>
      <button type="button" class="toolbar-btn" (click)="format('justifyCenter')">Center</button>
      <button type="button" class="toolbar-btn" (click)="format('justifyRight')">Right</button>
      <button type="button" class="toolbar-btn" (click)="format('justifyFull')">Justify</button>

      <div class="toolbar-color-wrap">
        <button
          type="button"
          class="toolbar-color-apply"
          (mousedown)="saveSelection()"
          (click)="applyTextColor()"
          title="Apply text color">
          Text
        </button>
        <input
          type="color"
          class="toolbar-color"
          [value]="textColor"
          (mousedown)="saveSelection()"
          (change)="setTextColor($any($event.target).value)"
          title="Change text color" />
      </div>
      <div class="toolbar-color-wrap">
        <button
          type="button"
          class="toolbar-color-apply"
          (mousedown)="saveSelection()"
          (click)="applyHighlight()"
          title="Apply highlight">
          Mark
        </button>
        <input
          type="color"
          class="toolbar-color"
          [value]="highlightColor"
          (mousedown)="saveSelection()"
          (change)="setHighlightColor($any($event.target).value)"
          title="Change highlight color" />
      </div>

      <label class="toolbar-btn file-btn" for="localImageInput">Image</label>
      <input id="localImageInput" type="file" accept="image/*" class="file-input" (change)="insertImageFromFile($event)" />
      <button type="button" class="toolbar-btn" (click)="openTableDialog()">Table</button>
      <button type="button" class="toolbar-btn" (click)="insertHorizontalRule()">Line</button>
      <button type="button" class="toolbar-btn" (click)="insertPageBreak()">Page Break</button>
      <button type="button" class="toolbar-btn" (click)="removeFormatting()">Clear Format</button>
      <button type="button" class="toolbar-btn" (click)="format('undo')">Undo</button>
      <button type="button" class="toolbar-btn" (click)="format('redo')">Redo</button>
      <!-- <button type="button" class="toolbar-btn export-btn export-word-btn" (click)="exportAsWord()">
        <span class="export-btn-icon" aria-hidden="true">W</span>
        <span class="export-btn-label">Export as Word</span>
      </button> -->
      <button
        type="button"
        class="autosave-status"
        [ngClass]="'autosave-' + draftState"
        (click)="manualSaveDraft()"
        [title]="draftSavedLabel ? 'Changes save automatically. Last saved: ' + draftSavedLabel : 'Changes save automatically'"
        role="status"
        aria-live="polite"
      >
        <span class="autosave-dot" aria-hidden="true"></span>
        <span class="autosave-text">{{ draftStatusLabel }}</span>
      </button>
      <button type="button" class="toolbar-btn export-btn export-pdf-btn" (click)="openExportDialog()" [disabled]="exportInProgress">
        <span class="export-btn-icon" aria-hidden="true">PDF</span>
        <span class="export-btn-label">Save &amp; Export as PDF</span>
      </button>
      <button type="button" class="toolbar-btn danger" (click)="clearEditor()">Clear Doc</button>
      <button type="button" class="toolbar-btn close-btn" (click)="closeEditor()" aria-label="Close document editor">
        Close
      </button>
    </div>

    <div class="draft-restore-banner" *ngIf="draftRestoreAvailable">
      <span class="draft-restore-icon" aria-hidden="true">&#8635;</span>
      <span class="draft-restore-text">
        <strong>Unsaved edits found</strong>
        <span class="draft-restore-sub" *ngIf="draftSavedLabel">from {{ draftSavedLabel }}</span>
      </span>
      <div class="draft-restore-actions">
        <button type="button" class="draft-btn draft-btn-restore" (click)="restoreDraft()">
          <span class="draft-btn-icon" aria-hidden="true">&#8635;</span>
          Restore edits
        </button>
        <button type="button" class="draft-btn draft-btn-dismiss" (click)="dismissDraft()">Dismiss</button>
      </div>
    </div>

    <div class="drop-notice" *ngIf="dropNotice" role="status">
      <span class="drop-notice-icon" aria-hidden="true">&#9888;</span>
      <span class="drop-notice-text">{{ dropNotice }}</span>
      <button
        type="button"
        class="drop-notice-close"
        (click)="dismissDropNotice()"
        title="Dismiss"
      >&#10005;</button>
    </div>

    <div class="draft-save-error" *ngIf="draftSaveError">
      Couldn't save a local draft (the document may be too large for browser storage). Use Export as PDF to keep your work.
    </div>

    <div
      class="pages-workspace"
      #pagesWorkspaceRef
      (scroll)="onWorkspaceScroll()"
      (mousemove)="onWorkspaceMouseMove($event)"
      (mouseleave)="scheduleHideTableControls()"
    >
      <div
        class="doc-page"
        *ngFor="let page of pages; let i = index"
        [class.active]="i === activePageIndex"
        [class.cover-page]="isMorReport && i === 0"
        (click)="setActivePage(i)"
      >
        <div class="page-header">
          <img
            src="assets/images/logo-wwtp.png"
            alt="WWTP Logo"
            class="page-header-logo"
          />
        </div>
        <div
          #pageEditor
          class="page-editor"
          contenteditable="true"
          dir="ltr"
          spellcheck="true"
          (mousedown)="onEditorMouseDown($event, i)"
          (click)="onEditorClick($event, i)"
          (focus)="setActivePage(i)"
          (input)="onPageInput(i)"
          (paste)="onEditorPaste($event, i)"
          (keydown)="onEditorKeydown($event, i)"
          (dragstart)="onEditorDragStart($event, i)"
          (dragover)="onEditorDragOver($event, i)"
          (drop)="onEditorDrop($event, i)"
          (dragend)="onEditorDragEnd()"
        ></div>
        <div class="page-footer">
          <span>Page {{ i + 1 }}</span>
        </div>
      </div>
    </div>

    <div class="editor-footer">
      <span>Page {{ currentPageIndex + 1 }} of {{ pages.length }}</span>
      <span>Words: {{ wordCount }}</span>
      <span>Characters: {{ characterCount }}</span>
    </div>

  </div>

  <div class="editor-dialog-backdrop" *ngIf="exportDialogOpen" (click)="closeExportDialog()"></div>
  <div class="editor-dialog insert-dialog" *ngIf="exportDialogOpen">
    <div class="insert-dialog-head">
      <div class="insert-dialog-head-text">
        <h3 class="editor-dialog-title">Save &amp; Export as PDF</h3>
        <p class="insert-dialog-subtitle">
          Name the file. The editable document is saved under this name (so you
          can reopen and edit it later), then the PDF is exported.
        </p>
      </div>
      <button type="button" class="insert-dialog-close" (click)="closeExportDialog()" aria-label="Close">&times;</button>
    </div>
    <div class="insert-dialog-body">
      <label class="dialog-label">File name</label>
      <div class="export-filename-row">
        <input
          type="text"
          class="dialog-input"
          [(ngModel)]="exportFileName"
          placeholder="Document"
          (keyup.enter)="confirmExportDialog()"
        />
        <span class="export-filename-ext">.pdf</span>
      </div>
    </div>
    <div class="insert-dialog-actions">
      <button type="button" class="insert-btn-cancel" (click)="closeExportDialog()">Cancel</button>
      <button type="button" class="insert-btn-confirm" (click)="confirmExportDialog()">Save &amp; Export</button>
    </div>
  </div>

  <!-- Entry-choice dialog: shown before anything is loaded/rendered. Two blank
       sections split by a centered divider; "Continue with Existing" runs the
       current render flow. The two sections are intentionally empty for now. -->
  <div class="editor-dialog-backdrop" *ngIf="entryDialogOpen"></div>
  <div class="editor-dialog entry-choice-dialog" *ngIf="entryDialogOpen">
    <button
      type="button"
      class="entry-choice-close"
      (click)="closeEntryDialog()"
      aria-label="Close">
      &times;
    </button>
    <div class="entry-choice-body">
      <div class="entry-choice-section entry-choice-left">
        <h3 class="entry-choice-title">
          Apply the data configuration to the generated PDF report.
        </h3>

        <!-- MOR name (required) — kept OUTSIDE the data-range loading gate so the
             user can name the MOR and Continue/Apply even while the available data
             range is still loading. -->
        <div class="entry-mor-field" *ngIf="isMorReport">
          <label class="dialog-label entry-mor-label">
            MOR Name <span class="entry-mor-required" aria-hidden="true">*</span>
          </label>

          <!-- Default: a single MOR name input with a button beside it that opens
               the line-by-line builder. -->
          <div class="entry-mor-single" *ngIf="!morMultiLineOpen">
            <input
              type="text"
              class="dialog-input entry-mor-line-input"
              [class.entry-mor-input-error]="morNameError"
              [(ngModel)]="morNameLines[0]"
              (ngModelChange)="onMorNameLineChange()"
              placeholder="Enter MOR name" />
            <button
              type="button"
              class="entry-mor-multiline-btn"
              (click)="openMorMultiLine()"
              title="Custom multi-line title">
              <span aria-hidden="true">&#9776;</span> Custom
            </button>
          </div>

          <!-- Line-by-line title builder (revealed by the button): Line 1 is
               required; "Add line" reveals the next line only once the current one
               is filled, so lines are always filled top-down. Empty lines never
               render. -->
          <ng-container *ngIf="morMultiLineOpen">
            <div class="entry-mor-lines">
              <div
                class="entry-mor-line"
                *ngFor="let line of morNameLines; let li = index; trackBy: trackByIndex">
                <span class="entry-mor-line-no">{{ li + 1 }}</span>
                <input
                  type="text"
                  class="dialog-input entry-mor-line-input"
                  [class.entry-mor-input-error]="morNameError && li === 0"
                  [(ngModel)]="morNameLines[li]"
                  (ngModelChange)="onMorNameLineChange()"
                  [disabled]="isMorNameLineDisabled(li)"
                  [placeholder]="
                    li === 0 ? 'Line 1 (e.g. September-2025)' : 'Line ' + (li + 1)
                  " />
                <button
                  type="button"
                  class="entry-mor-line-btn entry-mor-line-remove"
                  *ngIf="li > 0"
                  (click)="removeMorNameLine(li)"
                  title="Remove line"
                  aria-label="Remove line">
                  &times;
                </button>
              </div>
            </div>

            <div class="entry-mor-actions">
              <button
                type="button"
                class="entry-mor-add-btn"
                (click)="addMorNameLine()"
                [disabled]="!canAddMorNameLine()"
                title="Add another line">
                <span aria-hidden="true">&plus;</span> Add line
              </button>
              <button
                type="button"
                class="entry-mor-collapse-btn"
                (click)="closeMorMultiLine()"
                title="Back to a single line">
                Single line
              </button>
            </div>
          </ng-container>

          <div class="entry-choice-error entry-mor-error" *ngIf="morNameError">
            {{ morNameError }}
          </div>
        </div>

        <p
          class="entry-text-report-note"
          *ngIf="!dataConfigLoading && !dataConfigError && textReportCount">
          {{ textReportCount }} text
          {{ textReportCount === 1 ? "report" : "reports" }} (headings / notes)
          are rendered as-is and aren't affected by these date ranges.
        </p>

        <div class="entry-choice-status" *ngIf="dataConfigLoading">
          Loading available data range…
        </div>
        <div
          class="entry-choice-status entry-choice-error"
          *ngIf="!dataConfigLoading && dataConfigError">
          {{ dataConfigError }}
        </div>

        <div
          class="entry-data-range"
          *ngIf="!dataConfigLoading && !dataConfigError">
          <!-- Daily / Weekly / Monthly, each with its own from/to range. The
               radio selects which interval Apply / Continue uses. -->
          <div
            class="entry-interval-block"
            *ngFor="let opt of pdfIntervalOptions"
            [class.expanded]="expandedIntervals[opt.value]">
            <div class="entry-interval-head">
              <span class="entry-interval-name">{{ opt.label }}</span>
            </div>

            <div class="entry-interval-fields">
              <div class="entry-data-field">
                <label class="dialog-label">Data from</label>
                <input
                  type="date"
                  class="dialog-input"
                  [(ngModel)]="intervalRanges[opt.value].from"
                  [min]="dataBoundsOldest"
                  [max]="dataBoundsNewest" />
              </div>
              <div class="entry-data-field">
                <label class="dialog-label">Data to</label>
                <input
                  type="date"
                  class="dialog-input"
                  [(ngModel)]="intervalRanges[opt.value].to"
                  [min]="dataBoundsOldest"
                  [max]="dataBoundsNewest" />
              </div>
            </div>

            <!-- Collapsible list of the reports that render under this config -->
            <div class="entry-reports-accordion">
              <button
                type="button"
                class="entry-reports-toggle"
                (click)="toggleIntervalAccordion(opt.value)"
                [attr.aria-expanded]="expandedIntervals[opt.value]">
                <span class="entry-reports-label">Reports</span>
                <span
                  class="entry-interval-count"
                  *ngIf="intervalReports[opt.value].length">
                  {{ intervalReports[opt.value].length }}
                </span>
                <span class="entry-interval-caret" aria-hidden="true">&#9662;</span>
              </button>

              <div
                class="entry-interval-reports"
                *ngIf="expandedIntervals[opt.value]">
                <div
                  class="entry-interval-empty"
                  *ngIf="!intervalReports[opt.value].length">
                  No reports configured.
                </div>
                <ul
                  class="entry-interval-report-list"
                  *ngIf="intervalReports[opt.value].length">
                  <li
                    class="entry-interval-report"
                    *ngFor="let report of intervalReports[opt.value]">
                    {{ report.name }}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="entry-apply-row">
            <span class="entry-apply-progress" *ngIf="applyInProgress">
              Processing report {{ applyCurrent }}/{{ applyTotal }}…
            </span>
            <button
              type="button"
              class="insert-btn-confirm entry-apply-btn"
              (click)="applyDataConfiguration()"
              [disabled]="applyInProgress">
              Apply <span aria-hidden="true">&rarr;</span>
            </button>
          </div>

          <div class="entry-choice-status entry-choice-error" *ngIf="applyError">
            {{ applyError }}
          </div>
        </div>
      </div>
      <div class="entry-choice-divider"></div>
      <div class="entry-choice-section entry-choice-right">
        <div class="entry-saved-header">
          <h3 class="entry-choice-title entry-saved-title">Saved Documents</h3>
          <div class="entry-saved-search-wrap">
            <i class="pi pi-search entry-saved-search-icon" aria-hidden="true"></i>
            <input
              type="text"
              class="dialog-input entry-saved-search"
              [(ngModel)]="savedDocSearch"
              placeholder="Search documents…"
              (click)="$event.stopPropagation()" />
          </div>
        </div>

        <div
          class="entry-choice-status entry-choice-error entry-saved-action-error"
          *ngIf="savedDocActionError">
          {{ savedDocActionError }}
        </div>

        <div class="entry-choice-status" *ngIf="savedDocsLoading">
          Loading saved documents…
        </div>
        <div
          class="entry-choice-status entry-choice-error"
          *ngIf="!savedDocsLoading && savedDocsError">
          {{ savedDocsError }}
        </div>
        <div
          class="entry-choice-status"
          *ngIf="!savedDocsLoading && !savedDocsError && !savedDocuments.length">
          No saved documents yet.
        </div>
        <div
          class="entry-choice-status"
          *ngIf="
            !savedDocsLoading &&
            !savedDocsError &&
            savedDocuments.length &&
            !filteredSavedDocuments.length
          ">
          No documents match your search.
        </div>

        <ul
          class="entry-saved-list"
          (scroll)="savedDocMenuId !== null && closeSavedDocMenu()"
          *ngIf="
            !savedDocsLoading && !savedDocsError && filteredSavedDocuments.length
          ">
          <li
            *ngFor="let doc of filteredSavedDocuments"
            class="entry-saved-item"
            [class.opening]="savedDocOpeningId === doc.id"
            (click)="openSavedDocument(doc)">
            <button
              type="button"
              class="entry-saved-kebab"
              (click)="toggleSavedDocMenu(doc, $event)"
              aria-label="More options"
              aria-haspopup="true">
              &#8943;
            </button>

            <div
              class="entry-saved-menu"
              *ngIf="savedDocMenuId === doc.id"
              [style.top.px]="savedDocMenuPos?.top"
              [style.right.px]="savedDocMenuPos?.right"
              (click)="$event.stopPropagation()">
              <ng-container *ngIf="savedDocConfirmDeleteId !== doc.id">
                <button
                  type="button"
                  class="entry-saved-menu-item"
                  (click)="onSavedDocMenuOpen(doc, $event)">
                  Open
                </button>
                <button
                  type="button"
                  class="entry-saved-menu-item danger"
                  (click)="onSavedDocMenuDelete(doc, $event)">
                  Delete
                </button>
              </ng-container>
              <div
                class="entry-saved-menu-confirm"
                *ngIf="savedDocConfirmDeleteId === doc.id">
                <span class="entry-saved-menu-confirm-text">
                  Delete this document?
                </span>
                <div class="entry-saved-menu-confirm-actions">
                  <button
                    type="button"
                    class="entry-saved-confirm-cancel"
                    (click)="cancelSavedDocDelete($event)"
                    [disabled]="savedDocDeletingId === doc.id">
                    Cancel
                  </button>
                  <button
                    type="button"
                    class="entry-saved-confirm-delete"
                    (click)="confirmSavedDocDelete(doc, $event)"
                    [disabled]="savedDocDeletingId === doc.id">
                    {{ savedDocDeletingId === doc.id ? "Deleting…" : "Delete" }}
                  </button>
                </div>
              </div>
            </div>

            <div class="entry-saved-item-main">
              <span class="entry-saved-name">{{ doc.documentName }}</span>
              <!-- Per-frequency ranges when available; else the legacy single span. -->
              <span
                class="entry-saved-ranges"
                *ngIf="doc.intervalWindows?.length; else legacyRange">
                <span
                  class="entry-saved-range-chip"
                  *ngFor="let win of doc.intervalWindows">
                  <span class="entry-saved-range-label">{{ win.label }}</span>
                  {{ win.from }} &rarr; {{ win.to }}
                </span>
              </span>
              <ng-template #legacyRange>
                <span
                  class="entry-saved-range"
                  *ngIf="doc.dataFrom && doc.dataTo">
                  {{ doc.dataFrom }} &rarr; {{ doc.dataTo }}
                </span>
              </ng-template>
            </div>
            <div class="entry-saved-meta">
              <span
                class="entry-saved-owner"
                *ngIf="doc.createdByName || doc.createdBy">
                Saved by {{ doc.createdByName || doc.createdBy }}
              </span>
              <span class="entry-saved-date">
                {{ doc.updatedAt | date: "MMM d, y h:mm a" }}
              </span>
            </div>
            <span class="entry-saved-opening" *ngIf="savedDocOpeningId === doc.id">
              Opening…
            </span>
          </li>
        </ul>
      </div>
    </div>
    <div class="entry-choice-actions">
      <button type="button" class="insert-btn-confirm entry-choice-continue" (click)="continueWithExisting()">
        Continue with Existing <span aria-hidden="true">&rarr;</span>
      </button>
    </div>
  </div>

  <!-- Apply change-review dialog: shown when some reports' chosen range differs
       from their original configured period. The user can review the changes
       (per frequency) or apply them directly. -->
  <div
    class="editor-dialog-backdrop apply-review-backdrop"
    *ngIf="applyConfirmOpen"
    (click)="onApplyCancel()"></div>
  <div
    class="editor-dialog insert-dialog apply-review-dialog"
    *ngIf="applyConfirmOpen">
    <div class="insert-dialog-head">
      <div class="insert-dialog-head-text">
        <h3 class="editor-dialog-title">Review changes before applying</h3>
        <p class="insert-dialog-subtitle">
          {{ applyChanges.total }}
          {{ applyChanges.total === 1 ? "report has" : "reports have" }}
          a date range different from the period they were originally configured
          with. Review the changes, or apply them directly.
        </p>
      </div>
      <button
        type="button"
        class="insert-dialog-close"
        (click)="onApplyCancel()"
        aria-label="Close">&times;</button>
    </div>

    <div class="apply-review-body" *ngIf="applyReviewOpen">
      <p class="apply-review-hint">
        Adjust any report's date range below, then apply.
      </p>
      <ng-container *ngFor="let opt of pdfIntervalOptions">
        <div class="apply-review-group" *ngIf="applyChanges[opt.value].length">
          <h4 class="apply-review-group-title">
            {{ opt.label }}
            <span class="entry-interval-count">
              {{ applyChanges[opt.value].length }}
            </span>
          </h4>
          <ul class="apply-review-list">
            <li
              class="apply-review-item"
              *ngFor="let change of applyChanges[opt.value]">
              <span class="apply-review-name">{{ change.name }}</span>
              <div class="apply-review-range">
                <span class="apply-review-old">
                  {{ change.originalFrom || "—" }} &rarr;
                  {{ change.originalTo || "—" }}
                </span>
                <span class="apply-review-arrow" aria-hidden="true">&rArr;</span>
                <span class="apply-review-edit">
                  <input
                    type="date"
                    class="dialog-input apply-review-date"
                    [(ngModel)]="change.newFrom"
                    [min]="dataBoundsOldest"
                    [max]="dataBoundsNewest"
                    aria-label="New from date" />
                  <span class="apply-review-dash" aria-hidden="true">&rarr;</span>
                  <input
                    type="date"
                    class="dialog-input apply-review-date"
                    [(ngModel)]="change.newTo"
                    [min]="dataBoundsOldest"
                    [max]="dataBoundsNewest"
                    aria-label="New to date" />
                </span>
              </div>
            </li>
          </ul>
        </div>
      </ng-container>

      <div class="apply-review-error" *ngIf="applyReviewError">
        {{ applyReviewError }}
      </div>
    </div>

    <div class="insert-dialog-actions">
      <button type="button" class="insert-btn-cancel" (click)="onApplyCancel()">
        Cancel
      </button>
      <button
        type="button"
        class="insert-btn-cancel apply-review-btn"
        *ngIf="!applyReviewOpen"
        (click)="onApplyReview()">
        Review changes in reports
      </button>
      <button
        type="button"
        class="insert-btn-confirm"
        (click)="onApplyProceed()">
        Apply
      </button>
    </div>
  </div>

  <div class="editor-dialog-backdrop" *ngIf="dialogType !== 'none'" (click)="closeDialog()"></div>
  <div class="editor-dialog insert-dialog" *ngIf="dialogType !== 'none'">
    <div class="insert-dialog-head">
      <div class="insert-dialog-head-text">
        <h3 class="editor-dialog-title">
          {{ dialogType === 'link' ? 'Insert Link' : 'Insert Table' }}
        </h3>
        <p class="insert-dialog-subtitle">
          {{ dialogType === 'link' ? 'Add a hyperlink to the selected text.' : 'Choose how many rows and columns to add.' }}
        </p>
      </div>
      <button type="button" class="insert-dialog-close" (click)="closeDialog()" aria-label="Close">&times;</button>
    </div>

    <div class="insert-dialog-body" *ngIf="dialogType === 'link'">
      <label class="dialog-label">URL</label>
      <input type="text" class="dialog-input" [(ngModel)]="linkUrl" placeholder="https://example.com" />
    </div>

    <div class="insert-dialog-body grid" *ngIf="dialogType === 'table'">
      <div>
        <label class="dialog-label">Rows</label>
        <input type="number" class="dialog-input" min="1" [(ngModel)]="tableRows" />
      </div>
      <div>
        <label class="dialog-label">Columns</label>
        <input type="number" class="dialog-input" min="1" [(ngModel)]="tableCols" />
      </div>
    </div>

    <div class="insert-dialog-actions">
      <button type="button" class="insert-btn-cancel" (click)="closeDialog()">Cancel</button>
      <button type="button" class="insert-btn-confirm" (click)="confirmDialog()">Insert</button>
    </div>
  </div>

  <div
    class="image-quick-toolbar visual-quick-toolbar"
    [class.is-collapsed]="!imageToolbarExpanded"
    *ngIf="imageToolbarVisible && !chartEditorOpen && !tableEditorOpen"
    [style.top.px]="imageToolbarTop"
    [style.right.px]="imageToolbarRight"
    (mousedown)="$event.stopPropagation()"
    (click)="$event.stopPropagation()"
  >
    <ng-container *ngIf="imageToolbarExpanded">
    <button type="button" class="toolbar-chip" (click)="zoomSelectedImageOut()">-</button>
    <button type="button" class="toolbar-chip" (click)="zoomSelectedImageIn()">+</button>
    <button type="button" class="toolbar-chip" (click)="slideSelectedImageLeft()">&larr;</button>
    <button type="button" class="toolbar-chip" (click)="slideSelectedImageRight()">&rarr;</button>
    <button type="button" class="toolbar-chip" (click)="moveSelectedImageUp()" title="Move Up (1px)">&uarr;</button>
    <button type="button" class="toolbar-chip" (click)="moveSelectedImageDown()" title="Move Down (1px)">&darr;</button>
    <button type="button" class="toolbar-chip" (click)="rotateSelectedImageLeft()" title="Rotate Left">&#x21BA;</button>
    <button type="button" class="toolbar-chip" (click)="rotateSelectedImageRight()" title="Rotate Right">&#x21BB;</button>
    <button type="button" class="toolbar-chip" (click)="openSelectedVisualEditor()">Edit</button>
    <button type="button" class="toolbar-chip" (click)="resetSelectedImageTransform()">Reset</button>
    <button type="button" class="toolbar-chip danger" (click)="deleteSelectedVisual()" title="Delete">Del</button>
    </ng-container>
    <button
      type="button"
      class="toolbar-chip toolbar-toggle"
      (click)="toggleImageToolbar()"
      [attr.aria-expanded]="imageToolbarExpanded"
      [title]="imageToolbarExpanded ? 'Hide options' : 'Show options'"
    >{{ imageToolbarExpanded ? '✕' : '⚙' }}</button>
  </div>

  <div
    class="image-quick-toolbar table-quick-toolbar"
    *ngIf="tableToolbarVisible && !chartEditorOpen && !tableEditorOpen"
    [style.top.px]="tableToolbarTop"
    [style.left.px]="tableToolbarLeft"
    (mousedown)="$event.stopPropagation()"
    (click)="$event.stopPropagation()"
  >
    <button type="button" class="toolbar-chip" (click)="transposeSelectedTable()" title="Switch rows and columns (transpose)">Rows ↔ Cols</button>
    <button type="button" class="toolbar-chip danger" (click)="deleteTableRow()" title="Delete row">Del Row</button>
    <button type="button" class="toolbar-chip danger" (click)="deleteTableColumn()" title="Delete column">Del Col</button>
    <button type="button" class="toolbar-chip danger" (click)="deleteTable()" title="Delete table">Del Table</button>
    <label class="toolbar-chip table-fill-chip" (mousedown)="captureCellColorTargets()" title="Fill selected cell(s)">
      Fill
      <input type="color" [value]="cellFillColor" (change)="applyCellFill($event)" />
    </label>
    <button type="button" class="toolbar-chip" (mousedown)="captureCellColorTargets()" (click)="applyCellFillScope('row')" title="Fill row with current color">Fill Row</button>
    <button type="button" class="toolbar-chip" (mousedown)="captureCellColorTargets()" (click)="applyCellFillScope('col')" title="Fill column with current color">Fill Col</button>
  </div>

  <button
    type="button"
    class="table-add-control table-add-col"
    *ngIf="tableControlsVisible"
    [style.top.px]="tableColAddTop"
    [style.left.px]="tableColAddLeft"
    (mouseenter)="cancelHideTableControls()"
    (mouseleave)="scheduleHideTableControls()"
    (mousedown)="$event.preventDefault(); $event.stopPropagation()"
    (click)="addColumnToHoveredTable(); $event.stopPropagation()"
    title="Add column"
    aria-label="Add column"
  >+</button>
  <button
    type="button"
    class="table-add-control table-add-row"
    *ngIf="tableControlsVisible"
    [style.top.px]="tableRowAddTop"
    [style.left.px]="tableRowAddLeft"
    (mouseenter)="cancelHideTableControls()"
    (mouseleave)="scheduleHideTableControls()"
    (mousedown)="$event.preventDefault(); $event.stopPropagation()"
    (click)="addRowToHoveredTable(); $event.stopPropagation()"
    title="Add row"
    aria-label="Add row"
  >+</button>

  <button
    type="button"
    class="table-del-control table-del-col"
    *ngIf="tableDelControlsVisible"
    [style.top.px]="tableDelColTop"
    [style.left.px]="tableDelColLeft"
    (mouseenter)="cancelHideTableControls()"
    (mouseleave)="scheduleHideTableControls()"
    (mousedown)="$event.preventDefault(); $event.stopPropagation()"
    (click)="deleteHoveredColumn(); $event.stopPropagation()"
    title="Delete column"
    aria-label="Delete column"
  >−</button>
  <button
    type="button"
    class="table-del-control table-del-row"
    *ngIf="tableDelControlsVisible"
    [style.top.px]="tableDelRowTop"
    [style.left.px]="tableDelRowLeft"
    (mouseenter)="cancelHideTableControls()"
    (mouseleave)="scheduleHideTableControls()"
    (mousedown)="$event.preventDefault(); $event.stopPropagation()"
    (click)="deleteHoveredRow(); $event.stopPropagation()"
    title="Delete row"
    aria-label="Delete row"
  >−</button>

  <div class="editor-dialog-backdrop" *ngIf="chartEditorOpen"></div>
  <div class="editor-dialog chart-editor-dialog" *ngIf="chartEditorOpen" (click)="$event.stopPropagation()">
    <div class="chart-editor-header">
      <h3 class="editor-dialog-title">Edit Chart Snapshot</h3>
      <div class="editor-dialog-actions chart-editor-header-actions">
        <button type="button" class="toolbar-btn" (click)="closeChartEditor()">Close</button>
        <button type="button" class="toolbar-btn primary" (click)="applyChartEditor()">Apply</button>
      </div>
    </div>

    <div class="editor-dialog-body grid chart-form-grid">
      <div class="chart-title-field chart-field">
        <label class="dialog-label">Chart Title</label>
        <input type="text" class="dialog-input" [(ngModel)]="chartEditorTitle" (ngModelChange)="onChartEditorFieldChange()" />
      </div>
      <div class="chart-date-label-field chart-field">
        <label class="dialog-label">Chart Type</label>
        <select
          class="dialog-input"
          [(ngModel)]="chartEditorChartType"
          (ngModelChange)="onChartEditorFieldChange()"
        >
          <option *ngFor="let option of chartTypeOptions" [value]="option.value">
            {{ option.label }}
          </option>
        </select>
      </div>
      <div class="chart-date-label-field chart-field">
        <label class="dialog-label">Chart Title Size</label>
        <input
          type="range"
          class="dialog-input"
          min="16"
          max="64"
          step="1"
          [style.--range-pct]="((chartEditorTitleSize - 16) / (64 - 16)) * 100 + '%'"
          [(ngModel)]="chartEditorTitleSize"
          (ngModelChange)="onChartEditorFieldChange()"
        />
        <div class="date-rotation-value">{{ chartEditorTitleSize }}px</div>
      </div>
      <div class="chart-date-label-field chart-field">
        <label class="dialog-label">Date Range Display</label>
        <select
          class="dialog-input"
          [(ngModel)]="chartEditorDateLabelMode"
          (ngModelChange)="onChartEditorFieldChange()"
        >
          <option value="all">Show all dates</option>
          <option value="auto">Show partial dates (auto)</option>
        </select>
      </div>
      <div class="chart-date-label-field chart-field">
        <label class="dialog-label">Date Label Rotation (deg)</label>
        <input
          type="range"
          class="dialog-input"
          min="-180"
          max="180"
          step="1"
          [style.--range-pct]="((chartEditorDateLabelRotation + 180) / 360) * 100 + '%'"
          [(ngModel)]="chartEditorDateLabelRotation"
          (ngModelChange)="onChartEditorFieldChange()"
        />
        <div class="date-rotation-value">{{ chartEditorDateLabelRotation }}°</div>
      </div>
      <div class="chart-date-label-field chart-field">
        <label class="dialog-label">Chart Title Color</label>
        <input
          type="color"
          class="dialog-input color-input"
          [(ngModel)]="chartEditorTitleColor"
          (ngModelChange)="onChartEditorFieldChange()"
        />
      </div>
      <div class="chart-date-label-field chart-field">
        <label class="dialog-label">Value Label Size</label>
        <input
          type="range"
          class="dialog-input"
          min="8"
          max="36"
          step="1"
          [style.--range-pct]="((chartEditorValueLabelSize - 8) / (36 - 8)) * 100 + '%'"
          [(ngModel)]="chartEditorValueLabelSize"
          (ngModelChange)="onChartEditorFieldChange()"
        />
        <div class="date-rotation-value">{{ chartEditorValueLabelSize }}px</div>
      </div>
      <div class="chart-date-label-field chart-field">
        <label class="dialog-label">Value Label Rotation (deg)</label>
        <input
          type="range"
          class="dialog-input"
          min="-90"
          max="90"
          step="1"
          [style.--range-pct]="((chartEditorValueLabelRotation + 90) / 180) * 100 + '%'"
          [(ngModel)]="chartEditorValueLabelRotation"
          (ngModelChange)="onChartEditorFieldChange()"
        />
        <div class="date-rotation-value">{{ chartEditorValueLabelRotation }}°</div>
      </div>
      <div class="chart-date-label-field chart-field">
        <label class="dialog-label">Legend Text Size</label>
        <input
          type="range"
          class="dialog-input"
          min="10"
          max="40"
          step="1"
          [style.--range-pct]="((chartEditorLegendSize - 10) / (40 - 10)) * 100 + '%'"
          [(ngModel)]="chartEditorLegendSize"
          (ngModelChange)="onChartEditorFieldChange()"
        />
        <div class="date-rotation-value">{{ chartEditorLegendSize }}px</div>
      </div>
      <div class="chart-date-label-field chart-field">
        <label class="dialog-label">X-Axis Label Size</label>
        <input
          type="range"
          class="dialog-input"
          min="7"
          max="30"
          step="1"
          [style.--range-pct]="((chartEditorXAxisLabelSize - 7) / (30 - 7)) * 100 + '%'"
          [(ngModel)]="chartEditorXAxisLabelSize"
          (ngModelChange)="onChartEditorFieldChange()"
        />
        <div class="date-rotation-value">{{ chartEditorXAxisLabelSize }}px</div>
      </div>
      <div class="chart-date-label-field chart-field">
        <label class="dialog-label">Y-Axis Label Size</label>
        <input
          type="range"
          class="dialog-input"
          min="7"
          max="30"
          step="1"
          [style.--range-pct]="((chartEditorYAxisLabelSize - 7) / (30 - 7)) * 100 + '%'"
          [(ngModel)]="chartEditorYAxisLabelSize"
          (ngModelChange)="onChartEditorFieldChange()"
        />
        <div class="date-rotation-value">{{ chartEditorYAxisLabelSize }}px</div>
      </div>
      <div class="chart-date-label-field chart-field">
        <label class="dialog-label">Title Space Top</label>
        <input
          type="range"
          class="dialog-input"
          min="0"
          max="200"
          step="1"
          [style.--range-pct]="(chartEditorTitlePadTop / 200) * 100 + '%'"
          [(ngModel)]="chartEditorTitlePadTop"
          (ngModelChange)="onChartEditorFieldChange()"
        />
        <div class="date-rotation-value">{{ chartEditorTitlePadTop }}px</div>
      </div>
      <div class="chart-date-label-field chart-field">
        <label class="dialog-label">Title Space Bottom</label>
        <input
          type="range"
          class="dialog-input"
          min="0"
          max="200"
          step="1"
          [style.--range-pct]="(chartEditorTitlePadBottom / 200) * 100 + '%'"
          [(ngModel)]="chartEditorTitlePadBottom"
          (ngModelChange)="onChartEditorFieldChange()"
        />
        <div class="date-rotation-value">{{ chartEditorTitlePadBottom }}px</div>
      </div>
      <div class="chart-date-label-field chart-field">
        <label class="dialog-label">Title Space Left</label>
        <input
          type="range"
          class="dialog-input"
          min="0"
          max="200"
          step="1"
          [style.--range-pct]="(chartEditorTitlePadLeft / 200) * 100 + '%'"
          [(ngModel)]="chartEditorTitlePadLeft"
          (ngModelChange)="onChartEditorFieldChange()"
        />
        <div class="date-rotation-value">{{ chartEditorTitlePadLeft }}px</div>
      </div>
      <div class="chart-date-label-field chart-field">
        <label class="dialog-label">Title Space Right</label>
        <input
          type="range"
          class="dialog-input"
          min="0"
          max="200"
          step="1"
          [style.--range-pct]="(chartEditorTitlePadRight / 200) * 100 + '%'"
          [(ngModel)]="chartEditorTitlePadRight"
          (ngModelChange)="onChartEditorFieldChange()"
        />
        <div class="date-rotation-value">{{ chartEditorTitlePadRight }}px</div>
      </div>
      <div class="chart-date-label-field chart-field">
        <label class="dialog-label">Multi-Axis</label>
        <label class="chart-switch">
          <input
            type="checkbox"
            [(ngModel)]="chartEditorMultiAxis"
            (ngModelChange)="onMultiAxisToggle()"
          />
          <span class="chart-switch-track"></span>
          <span class="chart-switch-text">{{ chartEditorMultiAxis ? "On" : "Off" }}</span>
        </label>
      </div>
      <div class="chart-bg-row chart-field chart-field-wide">
        <div class="chart-bg-field">
          <label class="dialog-label">Background Start</label>
          <input type="color" class="dialog-input color-input" [(ngModel)]="chartEditorBgStart" (ngModelChange)="onChartEditorFieldChange()" />
        </div>
        <div class="chart-bg-field">
          <label class="dialog-label">Background End</label>
          <input type="color" class="dialog-input color-input" [(ngModel)]="chartEditorBgEnd" (ngModelChange)="onChartEditorFieldChange()" />
        </div>
        <div class="chart-bg-field">
          <label class="dialog-label">Background Center</label>
          <input type="color" class="dialog-input color-input" [(ngModel)]="chartEditorBgCenter" (ngModelChange)="onChartEditorFieldChange()" />
        </div>
        <div class="chart-bg-field">
          <label class="dialog-label">Background Outer</label>
          <input type="color" class="dialog-input color-input" [(ngModel)]="chartEditorBgOuter" (ngModelChange)="onChartEditorFieldChange()" />
        </div>
      </div>
    </div>

    <div class="chart-editor-preview" *ngIf="chartEditorPreviewDataUrl">
      <img [src]="chartEditorPreviewDataUrl" alt="Chart Preview" class="chart-editor-preview-image" />
    </div>

    <div class="editor-dialog-body chart-series-editor">
      <div class="chart-series-row" *ngFor="let name of chartEditorSeriesNames; let i = index">
        <input type="text" class="dialog-input" [(ngModel)]="chartEditorSeriesNames[i]" (ngModelChange)="onChartEditorFieldChange()" [placeholder]="'Series ' + (i + 1)" />
        <input type="color" class="dialog-input color-input" [(ngModel)]="chartEditorSeriesColors[i]" (ngModelChange)="onChartEditorFieldChange()" />
        <label
          class="series-axis-check"
          [class.disabled]="!chartEditorMultiAxis"
          [title]="chartEditorMultiAxis ? 'Give this parameter its own axis' : 'Enable Multi-Axis first'"
        >
          <input
            type="checkbox"
            [(ngModel)]="chartEditorSeriesAxis[i]"
            [disabled]="!chartEditorMultiAxis"
            (ngModelChange)="onChartEditorFieldChange()"
          />
          <span>Axis</span>
        </label>
      </div>
    </div>

    <div class="chart-editor-note" *ngIf="chartEditorMessage">{{ chartEditorMessage }}</div>
    <div class="chart-editor-note muted">
      Tooltip interactivity is not available in snapshot mode. This editor updates visual chart styling and labels.
    </div>
  </div>

  <div class="editor-dialog-backdrop" *ngIf="tableEditorOpen"></div>
  <div class="editor-dialog chart-editor-dialog table-editor-dialog" *ngIf="tableEditorOpen" (click)="$event.stopPropagation()">
    <h3 class="editor-dialog-title">Edit Table Style</h3>

    <div class="editor-dialog-body grid table-editor-grid">
      <div>
        <label class="dialog-label">Title Background</label>
        <input type="color" class="dialog-input color-input" [(ngModel)]="tableEditorTitleBg" (ngModelChange)="onTableEditorFieldChange()" />
      </div>
      <div>
        <label class="dialog-label">Header Background</label>
        <input type="color" class="dialog-input color-input" [(ngModel)]="tableEditorHeaderBg" (ngModelChange)="onTableEditorFieldChange()" />
      </div>
      <div>
        <label class="dialog-label">Odd Row Background</label>
        <input type="color" class="dialog-input color-input" [(ngModel)]="tableEditorOddRowBg" (ngModelChange)="onTableEditorFieldChange()" />
      </div>
      <div>
        <label class="dialog-label">Even Row Background</label>
        <input type="color" class="dialog-input color-input" [(ngModel)]="tableEditorEvenRowBg" (ngModelChange)="onTableEditorFieldChange()" />
      </div>
      <div>
        <label class="dialog-label">Text Color</label>
        <input type="color" class="dialog-input color-input" [(ngModel)]="tableEditorTextColor" (ngModelChange)="onTableEditorFieldChange()" />
      </div>
      <div>
        <label class="dialog-label">Border Color</label>
        <input type="color" class="dialog-input color-input" [(ngModel)]="tableEditorBorderColor" (ngModelChange)="onTableEditorFieldChange()" />
      </div>
    </div>

    <div class="table-editor-layout">
      <label class="dialog-label">Title Align</label>
      <select class="dialog-input table-title-select" [(ngModel)]="tableEditorTitleAlign" (ngModelChange)="onTableEditorFieldChange()">
        <option value="left">Left</option>
        <option value="center">Center</option>
        <option value="right">Right</option>
      </select>
      <label class="dialog-label">Title Size</label>
      <input
        type="range"
        class="dialog-input table-title-range"
        min="10"
        max="40"
        step="1"
        [(ngModel)]="tableEditorTitleSize"
        (ngModelChange)="onTableEditorFieldChange()"
      />
      <span class="table-editor-hint">{{ tableEditorTitleSize }}px</span>
    </div>

    <div class="table-editor-layout">
      <label class="dialog-label">Layout</label>
      <button type="button" class="toolbar-btn" (click)="transposeTableFromEditor()" title="Swap rows and columns">Switch Rows ↔ Columns</button>
      <span class="table-editor-hint">Flip a wide table (parameters across the top) into a tall one (parameters down the side), or back.</span>
    </div>

    <div class="table-editor-preview-wrap">
      <label class="dialog-label">Preview</label>
      <div class="table-editor-preview" [innerHTML]="tableEditorPreviewHtml"></div>
    </div>

    <div class="chart-editor-note" *ngIf="tableEditorMessage">{{ tableEditorMessage }}</div>

    <div class="editor-dialog-actions">
      <button type="button" class="toolbar-btn" (click)="closeTableEditor()">Close</button>
      <button type="button" class="toolbar-btn primary" (click)="applyTableEditor()">Apply</button>
    </div>
  </div>
</section>

